export default {
  'attachment.title': 'Attachments',
  'attachment.subtitle': 'Attach supporting material here',
  'attachment.addFiles': 'Add files',
  'attachment.limit': 'MB limit',
  'attachment.infoText': 'Allowed file types are:',
  'footer.html': `<p data-testid="footer-terms-pp">
  By using this form you agree with our&nbsp;
  <a href="https://www.qbe.com/au/about/governance/website-terms" target="_blank" rel="noopener noreferrer">
    Website Terms
  </a>
  &nbsp;and&nbsp;
  <a href="https://www.qbe.com/au/about/governance/privacy-policy" target="_blank" rel="noopener noreferrer">
    Privacy Statement
  </a>
</p>`,
  'landing.form.heading': 'What do you want to do?',
  'landing.form.contentParagraph':
    'Use this form to report complaints or lodge feedback and compliments or a financial hardship application.',
  'landing.form.sectionHeading': 'Select the type of lodgement you want to complete',
  'landing.form.lodgement.0.label': 'Complaint',
  'landing.form.lodgement.1.label': 'Feedback',
  'landing.form.lodgement.2.label': 'Compliment',
  'landing.form.lodgement.3.label': 'Financial hardship application',
  'landing.form.submit.label': 'Continue',
  'consent.insured.form.heading': 'Tell us about you',
  'consent.contactReason.heading': 'Contact Reason',
  'consent.individualOrBusiness.sectionHeading': 'Are you an individual or a business?',
  'consent.individualOrBusiness.0.text': 'Individual',
  'consent.individualOrBusiness.1.text': 'Business',
  'consent.contactReason.policyNumber': 'What is the policy number?',
  'consent.contactReason.policyNumber.label': 'Policy number',
  'consent.contactReason.claimNumber': 'What is the claim number?',
  'consent.contactReason.claimNumber.label': 'Claim number',
  'consent.contactReason.contactInformation':
    'If you do not have all the information or if you need assistance, please call us on 1300 650 503.',
  'consent.contactReason.policyNumber.infoText':
    'You can find the policy number on the top right corner of the policy documents.',
  'consent.contactReason.claimNumber.infoText':
    'You can find the claim number on any claim documents that have been provided to you.',
  'consent.contactReason.webformInformation':
    'Please note, this webform is for providers to notify us about a complaint, if you have a complaint yourself please call us.',
  'consent.personalDetails.heading': 'Your details',
  'yourDetails.personalDetails.section': 'Personal details',
  'yourDetails.personalDetails.sectionHeading': 'Are you contacting us about a claim or a policy? ',
  'yourDetails.personalDetails.options.0.text': 'Claim',
  'yourDetails.personalDetails.options.1.text': 'Policy',
  'yourDetails.personalDetails.options.2.text': 'Other',
  'consent.personalDetails.name': 'Please enter your name ',
  'consent.personalDetails.organisation': 'What is the name of your organisation? ',
  'consent.contactDetails.heading': 'Contact details',
  'consent.contactDetails.email': 'What is your email address?',
  'consent.contactDetails.phoneNumber': 'What is your contact number?',
  'consent.contactDetails.contactTypeField.information':
    'I will be the contact for the complaint on behalf of the customer ',
  'consent.contactDetails.contactTypeField.details':
    'If you select ‘Yes’ you will be the primary contact for this complaint and responsible for communicating with the customer.',
  'consent.contactDetails.preferedContactType': 'What is your preferred method of contact?',
  'consent.contactDetails.preferedContactType.infoText':
    'Collecting your details means that we can contact you the way you want us to about this complaint.',
  'consent.contactDetails.postalAddress': 'What is your postal address? ',
  'consent.contactDetails.addressType': 'Is your postal address the same as your residential address? ',

  'insured.customerDetails.heading': 'Customer’s details',
  'insured.customerDetails.sectionHeading': 'Is the customer an individual or a business? ',
  'insured.customerDetails.customerTitle': 'What is your title?',
  'insured.customerDetails.customerTitle.label': 'Title',
  'insured.customerDetails.customerName': 'Please enter your name',
  'insured.customerDetails.customerName.firstName.label': 'First name',
  'insured.customerDetails.customerName.lastName.label': 'Last name',
  'insured.customerDetails.dob': 'Date of birth',
  'insured.customerDetails.dob.infoText': 'If you do not wish to enter your date of birth, please enter 01/01/1900',
  'insured.customerDetails.gender': 'Gender',
  'insured.customerDetails.contactPersonTitle': 'What is the contact person’s title?',
  'insured.customerDetails.contactPersonName': 'Please enter the contact person’s name',
  'insured.customerDetails.contactPersonName.firstName.label': 'Contact first name',
  'insured.customerDetails.contactPersonName.lastName.label': 'Contact last name',
  'insured.customerDetails.submit.label': 'Continue',
  'insured.customerDetails.next.label': 'Next',
  'insured.contactDetails.heading': 'Contact details',
  'insured.contactDetails.preferedMethod': 'What is the customer’s preferred method of contact? ',
  'insured.contactDetails.preferedMethod.inofText':
    'Collecting these details means that we can contact the customer the way they want us to about this complaint',
  'insured.contactDetails.emailAddress': 'What is your email address?',
  'insured.contactDetails.residentialAddress': 'What is the customer’s residential address? ',
  'insured.contactDetails.addressType': 'Is the customer’s postal address the same as their residential address? ',
  'insured.contactDetails.phoneNumber': 'What is your contact number?',
  'insured.contactDetails.physicalAddress': 'What is your residential address?',
  'insured.contactDetails.postalAddress': 'What is your postal address?',

  'insured.otherDetails.vulnerability': 'Is the customer experiencing vulnerability? ',
  'insured.otherDetails.languageInterpreter': 'Is a language interpreter required? ',
  'insured.otherDetails.language': 'What is the language? ',
  'insured.otherDetails.otherLanguage': 'Please enter the language ',
  'insured.otherDetails.information':
    'Please provide any other information that is important for us to know about the customer.',
  'insured.otherDetails.businessName': 'What is your business name?',
  'insured.otherDetails.businessName.label': 'Business name',
  'insured.otherDetails.businessName.helpText': 'The legal name that the business operates under.',
  'insured.otherDetails.isSmallBusiness':
    'Are you operating a small business? (Defined as having 100 employees or less)',
  'insured.otherDetails.isSmallBusiness.0.text': 'Yes',
  'insured.otherDetails.isSmallBusiness.1.text': 'No',
  'insured.otherDetails.businessInfoText': 'The legal name that the business operates under.',
  'insured.otherDetails.smallBusiness.infoText': 'Defined as having 100 employees or less.',

  'complaint.form.heading': 'Tell us more',
  'complaint.details.complaintDate': 'When was the complaint raised with you? ',
  'Complaint.details.heading': 'Complaint information',
  'Complaint.details.product': 'Which product does the complaint relate to? ',
  'Complaint.details.compDescription': 'Please provide a description of the complaint ',
  'Complaint.details.compDescription.placeHolder': 'Please type here',
  'Complaint.details.sectionHeading': 'Are you contacting us about a claim or a policy?',
  'complaint.details.complaintType': 'Which of the below does the complaint relate to? ',
  'complaint.details.complaintCategory': 'Please select one or two categories that best relate to this complaint? ',
  'complaint.details.isSensitive': 'Is this a sensitive complaint? ',
  'complaint.details.isResolved': 'Have you resolved this complaint with the customer? ',
  'complaint.details.resolvedDate': 'What is the date the complaint was resolved? ',
  'complaint.details.customer.desiredOutcome': 'What is the desired outcome of the complaint? ',
  'complaint.details.customer.desiredOutcome.label': 'Please type here',
  'complaint.details.complaint.outcome': 'What is the outcome of the complaint? ',
  'complaint.details.outcomeDescription': 'Describe the outcome in further detail ',
  'complaint.details.amountInDispute': 'If applicable, what is the amount in dispute?',
  'complaint.details.amountInDispute.label': 'Amount in dispute',
  'complaint.details.amountResolved': 'How much money was paid to resolve the complaint?',
  'complaint.details.sensitive.infoText':
    'Select ‘yes’ if the customer is a QBE employee, public figure, high profile figure, or the information must be kept private for security reasons.',
  'complaint.details.complaintType.infoText':
    'This information helps us ensure the right person handles the complaint. ',
  'complaint.details.complaintCategory.infoText':
    'This information helps us ensure the right person handles the complaint.',
  'success.form.content':
    'Thanks for contacting QBE. We’ll review the information you have provided and get back to you as soon as we can.',
  'success.form.title': 'Thank you',
  'complaint.navigationTemplate.contactUs': 'Contact us: 1300 650 503',
  'Compliment.details.heading': 'Compliment details',
  'Compliment.details.sectionHeading': 'Which of the below does your compliment relate to?',
  'Compliment.details.product': 'Which product does your compliment relate to?',
  'Compliment.details.compType': 'What does your compliment relate to? ',
  'Compliment.details.compArea': 'What is the reason for your compliment? ',
  'Compliment.details.compDescription': 'Tell us about your compliment? ',
  'Compliment.details.reason.label': 'Compliment reason',
  'Compliment.details.compDescription.placeHolder': 'Compliment description',
  'compliment.details.success': 'Thank you for contacting QBE.',

  'Feedback.details.heading': 'Feedback details',
  'Feedback.details.sectionHeading': 'Which of the below does your feedback relate to?',
  'Feedback.details.product': 'Which product does your feedback relate to?',
  'Feedback.details.productType.label': 'Product',
  'Feedback.details.compType': 'What does your feedback relate to?',
  'Feedback.details.compType.sales.text': 'Sales',
  'Feedback.details.compType.claims.text': 'Claims',
  'Feedback.details.compType.finHard.text': 'Financial hardship application',
  'Feedback.details.compArea': 'What is the reason for your feedback?',
  'Feedback.details.reason.label': 'Feedback reason',
  'Feedback.details.compDescription': 'Tell us about your feedback?',
  'Feedback.details.compDescription.placeHolder': 'Feedback description',
  'Feedback.details.submit.label': 'Submit',

  'Feedback.Compliment.contactReason.contactInformation':
    'If you do not have all the information or if you need assistance please give us a call on 1300 650 503',

  'Financial.contactReason.contactInformation':
    'If you do not have all the information or if you need assistance, please call us on 1300 902 417.',
  'Financial.personalDetails.sectionHeading': 'Is your application about a claim or a policy? ',
  'Financial.dependents.heading': 'Dependent information',
  'Financial.dependents.infoText': 'This is a person who you are legally and/or financially responsible for',
  'Financial.dependents.infoHeading': 'Please add your dependents',
  'Financial.dependents.btn': 'Add dependents',
  'Financial.contactDetails.preferedContactType.infoText':
    'Collecting your details means that we can contact you the way you want us to about this application.',
  'Financial.navigationTemplate.contactUs': 'Contact QBE Financial Hardship Support on 1300 902 417',
  'Financial.details.nominatedRepType':
    'Would you like to nominate a representative to handle the application on your behalf? ',
  'Financial.details.repName': "What is the nominated representative's name? ",
  'Financial.details.repContactMethod': 'What is their preferred method of contact? ',
  'Financial.contactDetails.repPreferedContactType.infoText':
    'Collecting these details means that we can contact the nominated representative the way they want us to about this application',
  'Financial.details.emailAddress': 'What is their email address? ',
  'Financial.details.postalAddress': 'What is their postal address? ',
  'Financial.details.contactNumber': 'What is their contact number? ',
  'Financial.details.physicalAddress': 'What is your residential address? ',
  'Financial.details.addressType': 'Is your postal address the same as your residential address?',

  'Hardship.details.formHeading': 'Tell us more',
  'Hardship.details.heading': 'Hardship details',
  'Hardship.details.reason': 'What is the reason for your application? ',
  'Hardship.details.reasonPlaceholder': 'Circumstances of hardship',
  'Hardship.details.assistance': 'What assistance would you like QBE to consider? ',
  'Hardship.details.assistancePlaceholder': 'Nature of assistance',
  'Hardship.details.description': 'Please provide a description of the assistance required',
  'Hardship.details.descriptionPlaceholder': 'Description of assistance',
  'Hardship.details.submit.label': 'Continue',

  'fha.your.details.policyError.title': 'For Policy related assistance',
  'fha.your.details.policyError.message': 'policyTextAlert',
  'fha.your.details.policyError.alert': `<p>
  <strong> Lenders Mortgage Insurance </strong> – go to LMI&nbsp;
  <a
    href="https://www.qbe.com/media/qbe/apac/lenders-mortgage-insurance/files/hardship-repayment-assistance-changes.pdf"
    target="_blank"
    rel="noopener noreferrer"
  >
    Hardship Assistance
  </a>
  &nbsp;
</p>
<p>
  <strong> Business insurance bought through a broker </strong> - if your small business insurance is purchased
  through a broker please speak to them if you are needing financial assistance relating to your insurance
  premium. QBE will work with your broker to understand your businesses circumstances and establish what support
  can be organised. You will need to provide your broker an overview of your current circumstances and current
  financial status as part of this assessment.{' '}
</p>
<p>
  <strong> Insurance premiums </strong> - call 133 723 Mon-Fri 8am-8pm, Sat 8am-1.30pm (AEST/ADST).
</p>`,

  'Employment.details.formHeading': 'Employment',
  'Employment.details.heading': 'Employment details',
  'Employment.details.employmentStatus': 'Are you currently employed? ',
  'Employment.details.employmentType': 'Please select your type of employment ',
  'Employment.details.employmentType.label': 'Employment type',
  'Employment.details.employerName': 'Enter the business name of your employer ',
  'Employment.details.employerName.label': 'Company name',
  'Employment.details.occupation': 'Enter your occupation ',
  'Employment.details.occupation.label': 'Occupation',
  'Employment.details.contactPerson': 'Enter the contact name for this employer',
  'Employment.details.contactPerson.label': 'Contact person',
  'Employment.details.contactPersonNumber': 'Enter the contact phone number for this employer',
  'Employment.details.contactPersonNumber.label': 'Contact number',
  'Employment.details.salary': 'How much do you earn per month from this employer? ',
  'Employment.details.salary.label': 'Net earnings per month',
  'Employment.details.salaryInfo': 'Net earnings is the amount received after tax e.g. tax, superannuation',
  'Employment.details.summary': 'Employment summary',
  'Employment.details.submit.label': 'Continue',
  'Employment.details.addEmployer.label': 'Add another employer',
  'Employment.details.removeEmployer.label': 'Remove',

  'Employment.summary.employmentType': 'Employment type',
  'Employment.summary.employerName': 'Employer name',
  'Employment.summary.occupation': 'Occupation',
  'Employment.summary.contactPerson': 'Contact person',
  'Employment.summary.contactPersonNumber': 'Contact number',
  'Employment.summary.salary': 'Earnings per month',

  'Income.details.formHeading': 'Income / Expenses',
  'Income.details.heading': 'Other income details',
  'Income.details.incomeStatus': 'Do you have any other forms of income? ',
  'Income.details.editHeading': 'Income details',
  'Income.details.incomeType': 'Please select the type of income ',
  'Income.details.incomeType.label': 'Other income type',
  'Income.details.incomeDescription': 'Enter a description of the income ',
  'Income.details.incomeDescription.label': 'Income description',
  'Income.details.incomeAmount': 'How much do you earn per month from this source of income? ',
  'Income.details.incomeAmount.label': 'Income per month',
  'Income.details.incomeAmountInfo': 'Please use Australian dollar',
  'Income.details.summary': 'Income/Expenses summary',
  'Income.details.addIncome.label': 'Add another income',
  'Income.details.removeIncome.label': 'Remove',
  'Income.details.submit.label': 'Continue',

  'Income.summary.incomeType': 'Other income type',
  'Income.summary.incomeAmount': 'Earnings per month',
  'Income.summary.incomeDescription': 'Description',

  'Expense.details.formHeading': 'Please enter your monthly expenses',
  'Expense.details.heading': 'Expense details',
  'Expense.details.label.rent': 'Rent/Mortgage',
  'Expense.details.label.child': 'Child support',
  'Expense.details.label.otherLoan': 'Other loan',
  'Expense.details.label.motor': 'Motor vehicle',
  'Expense.details.label.credit': 'Credit card',
  'Expense.details.label.living': 'Living costs',
  'Expense.details.label.util': 'Utilities',
  'Expense.details.label.school': 'School fees',
  'Expense.details.label.hospital': 'Hospital/medical costs',
  'Expense.details.label.insurance': 'Insurance',
  'Expense.details.label.other': 'Other',
  'Expense.details.declaration.heading': 'Declaration',
  'Expense.details.declaration.text': 'I/We declare that the information provided is true and correct.',
  'Expense.details.continue': 'Continue',
  'Expense.modal.title': 'Important information',
  'Expense.modal.submit': 'Submit',
  'Expense.modal.content': `<p> Please send relevant supporting information to:</p>
  <ul>
    <li>
      Email: <a href="mailto:hardshipsupport@qbe.com">hardshipsupport@qbe.com</a>
    </li>

    <li>Post: Financial Hardship Support, PO Box 84, Lismore NSW 2480</li>
  </ul>
  <p>The following documents may be required if they are relevant to your circumstances:</p>
  <ul>
    <li>Copies of most recent payslips</li>
    <li>Copies of most recent Centrelink statements</li>
    <li>Letter from former employer confirming loss of employment</li>
    <li>
      Letter from charitable organisation regarding loss of employment or inability to provide for basic necessities
    </li>
    <li>Bank notice regarding unpaid overdraft or repossession of mortgaged property</li>
    <li>Eviction notice</li>
    <li>Copies of unexpected bills/payments</li>
    <li>Pending disconnection of essential service/s</li>
    <li>Repossession notice of essential items e.g. car, motorcycle</li>
    <li>Funeral expenses</li>
    <li>Notice of impending legal action</li>
    <li>Family law court document regarding changes</li>
    <li>
      Letter from doctor confirming inability to earn income due to disability, injury, illness or caring for a sick
      family member
    </li>
    <li>Overdue medical bills</li>
  </ul>`,

  'address.country': 'Country',
  'address.streetAddress': 'Street address',
  'address.suburb': 'Suburb',
  'address.state': 'State',
  'address.postcode': 'Postcode',
  'address.invalidFieldError': 'Please enter a valid value',
  'address.invalidPostcodeError': 'Invalid postcode',
  'address.countryRequiredError': 'Country is a required field',
  'address.specialCharacterError':
    "For security reasons, only the following special characters are allowed: - / , . ' & ()",

  // TODO: Remove 'addressAutocomplete.unavailable' after QAS on-prem decommission
  'addressAutocomplete.unavailable':
    'Address search is unavailable right now, please enter the address manually via the link',
  'addressAutocomplete.includeUnitNumber': 'Remember to include your unit number as well as your street number',
  // NEW - QAS/DFC-migrated content strings
  'addressAutocomplete.apiUnavailable':
    'Address search is unavailable right now, please enter the address using the link manually below',
  'addressAutocomplete.cantFindTheAddress': 'Can’t find the address?',
  'addressAutocomplete.enterItManually': 'Enter it manually',
  'addressAutocomplete.addressSearchIncludeUnitNumber': 'If applicable, include your unit number',
  'addressAutocomplete.noResults': 'No results found',
  'addressAutocomplete.returnToLookupText': '< Try searching again',

  'contactPreferred.email': 'Email',
  'contactPreferred.post': 'Post',
  'contactPreferred.phone': 'Phone',

  'contactNumber.mobile': 'Mobile phone',
  'contactNumber.home': 'Home phone',
  'contactNumber.other': 'Other phone',

  'dependentItem.name': 'Name:',
  'dependentItem.age': 'Age:',

  'contactUs.normal.subtitle': 'Contact us',
  'contactUs.normal.number': '1300 650 503',
  'contactUs.hardship.subtitle': 'Contact QBE Financial Hardship Support',
  'contactUs.hardship.number': '1300 902 417',

  'internalErrorMessage.title': 'Error',
  'internalErrorMessage.description': `Something has gone wrong. We apologise for any inconvenience. Please try again later or give us a call on
  1300 650 503.`,

  'alertBanner.defaultErrorMsg':
    'Something has gone wrong. We apologise for any inconvenience. Please try again later or give us a call on 1300 650 503.',
  'alertBanner.defaultTitle': 'Submission unsuccessful',
};
